import axios from "axios";
import { supabase } from "../supabaseClient";
import { errorTost, offlineToast } from "./Toast";

const apiUrl = process.env.REACT_APP_PAYMENT_LINK_URL;
// const apiUrl = 'http://localhost:8053/';
async function checkPhoneNumberIsBlackListed(number) {
	// number = number.substring(1);
	//   console.log(number);
	// const { data, error } = await supabase
	//   .from('BlacklistNumbers')
	//   .select('number')
	//   .eq('number', number);
	// if (data) return data;
	// else throw error;
	return new Promise((resolve, reject) => {
		number = number.substring(1);
		axios
			.post(apiUrl + "users/checkIfAuthorized", { number })
			.then((resp) => {
				resolve(resp.data);
			})
			.catch((err) => {
				reject(err);
			});
	});
}
async function getLead(number) {
	// const { data, error } = await supabase.from('Person').select('*, Leads(*,personId(*),userId(userId,name,email,contactNumber,roleId,parentId(*)),cpId(billingName,cpId),fosId(name,fosId),LeadStatus!left(*))!left(*)')
	//   .eq('contactNumber', number)
	//   .order('last_updated_at', { ascending: false });
	// // .order('Leads.last_updated_at', { ascending: false });

	// // const { data, error } = await supabase.from('Leads').select('*,personId(*),userId(userId,name),cpId(billingName,cpId),fosId(name,fosId)').eq('leadDisplayId', leadId);
	// if (data) return data;
	// else throw error;
	return new Promise((resolve, reject) => {
		axios
			.post(apiUrl + "users/getCuid", { number })
			.then((resp) => {
				resolve(resp.data);
			})
			.catch((err) => {
				reject(err);
			});
	});
}
function handleErrors(error, page, data) {
	if (error?.message?.includes("FetchError: Failed to fetch") || error?.message?.includes("Network Error")) {
		//   Network.getStatus().then((resp) => {
		//     if (resp.connected) {
		//       offlineToast();
		//     } else {
		//       errorTost('Something went wrong!');
		//     }
		//   });
	} else {
		if (error?.message?.includes('duplicate key value violates unique constraint "CP_billingName_key"')) {
			errorTost(`CP with Billing Name ${data} already exists`);
		} else if (error?.message?.includes("User already registered")) {
			errorTost("Contact Person already exists");
		} else if (error?.message?.includes("BlacklistNumbers_number_key")) {
			errorTost("Number is blacklisted");
		} else if (error?.message?.includes("You must provide either an email, phone number, a third-party provider or OpenID Connect.")) {
			errorTost("Invalid Credentials");
		} else {
			errorTost(error.message);
		}
	}
}

async function getVirtualAccountStatus(virtualAccId) {
	const response = await axios.post(process.env.REACT_APP_PAYMENT_LINK_URL + "payments/getVirtualAccStatus", { virtualAccId: virtualAccId });
	return response;
}

async function checkLeadEmailExists(email) {
	const { data, error } = await supabase.from("Person").select("email").eq("email", email);
	if (data) return data;
	else throw error;
}
async function checkLeadEmailExistsInUsers(email) {
	const { data, error } = await supabase.from("Users").select("email").eq("email", email);
	if (data) return data;
	else throw error;
}
async function checkLeadEmailExistsInCp(email) {
	const { data, error } = await supabase.from("CpContactPerson").select("email").eq("email", email);
	if (data) return data;
	else throw error;
}
async function logIn(number, cuid) {
	return new Promise(async (resolve, reject) => {
		axios
			.post(apiUrl + "users/signIn", { number, cuid })
			.then(async (resp) => {
				// console.log("login time===>", new Date());
				if (resp?.data?.success) {
					let authSession = {
						currentSession: resp.data.result.data.session,
						expiresAt: resp.data.result.data.session.expires_at,
					};
					localStorage.setItem("supabase.auth.token", JSON.stringify(authSession));
					const { data, error } = await supabase.auth.setSession({
						access_token: authSession.currentSession.access_token,
						refresh_token: authSession.currentSession.refresh_token,
					});
					// localStorage.setItem('accesstoken', JSON.stringify(authSession))
					resolve(resp.data.success);
				} else {
					reject(resp.data.success);
				}
			})
			.catch((err) => {
				reject(err);
			});
	});
}
async function logOut() {
	// console.log("logout time==>", new Date());
	return await supabase.auth.signOut();
}
// async function switchUserLogIn(number, cuid) {
//   return new Promise(async (resolve, reject) => {
//     supabase.auth.signOut().then((logOutRes) =>{

//       axios.post(apiUrl + 'users/signIn', { number, cuid }).then(async (resp) => {
//         if (resp?.data?.success) {
//           let authSession = {
//             currentSession: resp.data.result.data.session,
//             expiresAt: resp.data.result.data.session.expires_at
//           }
//           console.log('authSession: ', authSession);
//           localStorage.setItem('supabase.auth.token', JSON.stringify(authSession))
//           const { data, error } = await supabase.auth.setSession({
//             access_token: authSession.currentSession.access_token,
//             refresh_token: authSession.currentSession.refresh_token
//           })
//           // localStorage.setItem('accesstoken', JSON.stringify(authSession))
//           resolve(resp.data.success);
//         } else {
//           reject(resp.data.success);
//         }
//       }).catch((err) => {
//         reject(err);
//       });

//     })
//   });
// }
export {
	getLead,
	checkPhoneNumberIsBlackListed,
	handleErrors,
	checkLeadEmailExists,
	checkLeadEmailExistsInUsers,
	checkLeadEmailExistsInCp,
	getVirtualAccountStatus,
	logIn,
	logOut,
};
